import { Location } from '@angular/common';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from '../../../../../../Services/api.service';
import { DialogActionService } from '../../../../../../Services/dialog-actions.service';
import { StorageService } from '../../../../../../Services/storage.service';
import { SweetAlert } from '../../../../../../Services/sweetalet.service';
import { VehicleLiveTrackService } from '../../../../../../store/vehicle/reducer';
import { CommonServices } from '../../../../../../Services/common.service';
import { SharedService } from '../../../../../../Services/shared.service';
import { ExcelExportService } from 'src/app/Services/excel.service';



declare const Swal;

@Component({
  selector: 'view-vehicle',
  templateUrl: './view-vehicle.component.html',
  styleUrls: ['./view-vehicle.component.css']
})


export class ViewVehicleComponent {
  public vehicleExcelColumns = [
    { key: 'vehRegNo', label: 'Reg No', required: true, sampleValue: 'KA01AB1234' },
    { key: 'imei', label: 'IMEI', required: true, sampleValue: '123456789012345' },
    { key: 'model', label: 'Model', required: true, sampleValue: 'Sedan' },
    { key: 'capacity', label: 'Capacity', required: true, sampleValue: '4' },
    { key: 'vehicleType', label: 'Vehicle Type', required: true, sampleValue: 'Car' },
    { key: 'branch', label: 'Branch', required: true, sampleValue: 'Main Branch' },
    { key: 'vehRegDate', label: 'Vehicle Registration Date', required: true, sampleValue: 'DD/MM/YYYY' },
    { key: 'location', label: 'Location', required: true, sampleValue: 'Bengaluru' },
    { key: 'boxType', label: 'Box Type', required: true, sampleValue: 'G10 Gps Device / others' },
    { key: 'simNo', label: 'Sim No', required: false, sampleValue: '9876543210' },
    { key: 'vendorName', label: 'Vendor Name', required: false, sampleValue: 'Vendor One' },
    { key: 'status', label: 'Status', required: true, sampleValue: 'Active/Inactive' },
    { key: 'fuelType', label: 'Fuel Type', required: true, sampleValue: 'Diesel' },
    { key: 'rcStartDate', label: 'RC Start Date', required: true, sampleValue: 'DD/MM/YYYY' },
    { key: 'rcExpiryDate', label: 'RC Expiry Date', required: true, sampleValue: 'DD/MM/YYYY' },
    { key: 'pucExpiryDate', label: 'PUC Expiry Date', required: true, sampleValue: 'DD/MM/YYYY' },
    { key: 'fcExpiryDate', label: 'FC Expiry Date', required: true, sampleValue: 'DD/MM/YYYY' },
    { key: 'insuranceExpiryDate', label: 'Insurance Expiry Date', required: true, sampleValue: 'DD/MM/YYYY' }
  ];

  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };
  public toggleUploadVeh: boolean = false;
  public uploadedExcel: any;
  /* public totalVehicle =0; */
  public allCount: any;
  public xlFileName: any = '';
  public enableFileName: boolean = false;
  public vendorViewData: any = {};
  public allVehicleTotalInfo: any;
  /* public allVehicles: any; */
  public closeExlUploadAlert: boolean = true;
  public exlUploadPopup: boolean = true;
  public noVehicleEnable: boolean = false;

  public exlUploadRes: any;
  public exlUploadTable = [
    { key: 'vehRegNo', display: 'Reg No', config: { isVehicle: true } },
    { key: 'model', display: 'Model' },
    { key: 'capacity', display: 'Capacity' },
    { key: 'boxType', display: 'Box Type' },
  ]
  /* count */
  public vehicleData: any;
  public totalVehicle: any = {
    cnt: {
      all: 0,
      inActive: 0,
      active: 0
    },
    info: {
      all: [],
      active: [],
      inActive: [],
    }
  };
  public allVehicle = 0;
  public activeVehicle = 0;
  public inActiveVehicle = 0;
  public datacount: any;
  public activeVehicles: any;
  public inActiveVehicles: any;
  public generalSetting: boolean = false;
  public excelData = {};
  vehExcelData: any=[];

  constructor(
    public router: Router,
    public storage: StorageService,
    public dialogService: DialogActionService,
    public swal: SweetAlert,
    public location: Location,
    public api: ApiService,
    public route: ActivatedRoute,
    private share: SharedService,
    public excel: ExcelExportService,
    public socketStore: VehicleLiveTrackService,
    private comService: CommonServices
  ) {

    let userInfo = this.storage.get('userInfo');
    if (userInfo?.general?.event == true) this.generalSetting = true;
    this.route.paramMap.subscribe(params => {
      // console.log(params.get('orgID'));
      this.orgID = params.get('orgID');
      this.vendorID = params.get('vendorID');
      let vendorName = this.storage.get('vendorID_orgID')['vendorName'];
      if (vendorName) {
        vendorName = this.comService.strTruncate(vendorName, 13);
        this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
      } else {
        this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
      }
      this.breadcrumbData['Vehicles'] = '';
    });
    this.userType = this.storage.get('userType');
    this.share._subject.subscribe((data: any) => {
      // console.log('dashboard ', data);
      if (data.type == 'socketData') {
        this.filterData(this.selectedType);
        // console.log('socket -- ', data.data);
      }
    });

  }
  selectedType: any;

  userType: any;
  noDataMsg: string;
  orgID: string;
  vendorID: string;
  public values: any = [];
  public editForm: boolean;
  public filterTable: boolean = true;
  public tableShow: boolean = false;
  public cols = [
    { key: '#', display: '#' },
    {
      key: 'vehRegNo', display: 'Reg no', headerConfig: { isDefault: true },
      subKey: 'compRating',
      config: {
        isComplaint: true,  // give complaint first
        isVehicle: true
      }
    }, {
      key: 'imei', display: 'IMEI', headerConfig: { isDefault: true },
      config: {
        isImei: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
    { key: 'model', display: 'Model', config: { isAttendance: true, } },
    { key: 'capacity', display: 'Capacity' },
     {
      key: 'rcStartDate', display: 'RC start date', headerConfig: { isDefault: true },
      config: {
        isDate: true,
        format: 'dd MMM YYYY',
      }
    },
    {
      key: 'rcExpiryDate', display: 'RC expiry date', headerConfig: { isDefault: true },
      config: {
        isDate: true,
        format: 'dd MMM YYYY',
        isBadge: true,
        badgeData: [{
          key: 'expiryTrue', name: 'E', badgeClass: "badge-danger", title: 'RC date expiried'
        }],
      }
    },    {
      key: 'fcExpiryDate', display: 'FC expiry date', headerConfig: { isDefault: true },
      config: {
        isDate: true,
        format: 'dd MMM YYYY',
        isBadge: true,
        badgeData: [{
          key: 'expiryTrueFc', name: 'E', badgeClass: "badge-danger", title: 'FC date expiried'
        }],
      }
    },
    {
      key: 'insuranceExpiryDate', display: 'Insurance expiry date', headerConfig: { isDefault: true },
      config: {
        isDate: true,
        format: 'dd MMM YYYY',
        isBadge: true,
        badgeData: [{
          key: 'expiryTrueIns', name: 'E', badgeClass: "badge-danger", title: 'Insurance date expiried'
        }],
      }
    }, {
      key: 'pucExpiryDate', display: 'PUC expiry date', headerConfig: { isDefault: true },
      config: {
        isDate: true,
        format: 'dd MMM YYYY',
        isBadge: true,
        badgeData: [{
          key: 'expiryTruepuc', name: 'E', badgeClass: "badge-danger", title: 'PUC date expiried'
        }],
      }
    },
    {
      key: 'isActive', display: 'Status', config: {
        isYesOrNo: true,
        title: {
          yesTitle: 'Active',
          noTitle: 'In Active'
        }
      },
    },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View' },
          { display: 'Update', color: 'primary', icon: 'Edit', class: 'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' },
        ]
      }
    }
  ];

  public VehicleInfo;
  public enableTable: boolean = false;

  /* Pagination */
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };

  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';


  ngOnInit() {
    if (this.userType != 'transport_manager') {
      this.router.navigate(['/organization/transport-manager/login']);
    }
    setTimeout(() => { this.getListVehicle() }, 1000);
    this.getVendorData();
    this.getVehicleStatus();
    setTimeout(() => {
      this.loadTabContant('all');
    })
  }

  getListVehicle(page = 1, limit = 10, vehRegNo?) {
    // if (this.orgID && this.vendorID == null) {
    //   let obj = {
    //     orgID: this.storage.get('vendorID_orgID').orgID,
    //     vendorID: this.storage.get('vendorID_orgID').vendorID
    //   }
    // }
    const obj = {
      orgID: this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      page: page,
      limit: limit,
    };
    if (vehRegNo) obj['vehRegNo'] = vehRegNo;


    this.api.transportManagerVehicleList(obj).then((res: any) => {

      if (res.status == 'success') {
        this.activeVehicles = res.VehStatus['active']
        this.inActiveVehicles = res.VehStatus['inactive']
        this.processvehExcelData(res.data);
        this.processPagination(res, obj);
      }
    }).catch((err) => {
      console.log(err);
    });
  }


  processvehExcelData(data) {
    this.enableTable = false;
    this.VehicleInfo = data.map((veh) => {
      let obj = {
        vehRegNo: veh['vehRegNo'] ? veh['vehRegNo'] : '',
        make: veh['make'] ? veh['make'] : '',
        capacity: veh['capacity'] ? veh['capacity'] : '',
        vehicleInfo: veh['vehicleInfo'] ? veh['vehicleInfo'] : '',
        imei: veh['imei'] ? veh['imei'] : '',
        boxType: veh['boxType'] ? veh['boxType'] : '',
        model: veh['model'] ? (veh.model == 'loadVehicle' ? 'Load Vehicle' : veh.model) : '',
        rcExpiryDate: veh['rcExpiryDate'] ? veh['rcExpiryDate'] : '',
        fcExpiryDate:veh['fcExpiryDate'] ? veh['fcExpiryDate'] : '',
        rcStartDate: veh['rcStartDate'] ? veh['rcStartDate'] : '',
        vehicleID: veh['vehicleID'],
        compRating: (veh['compRating'] == 0 || veh['compRating']) ? veh['compRating'] : '',
        isActive: veh['isActive'] ? true : false,
        insuranceExpiryDate: veh['insuranceExpiryDate'] ? veh['insuranceExpiryDate'] : '',
        pucExpiryDate: veh['pucExpiryDate'] ? veh['pucExpiryDate'] : '',
      }
      if (veh['rcExpiryDate'] && this.isExpired(veh['rcExpiryDate']) == true) {
        obj['expiryTrue'] = this.isExpired(veh['rcExpiryDate']);
      } 
      if (veh['fcExpiryDate'] && this.isExpired(veh['fcExpiryDate']) == true) {
        obj['expiryTrueFc'] = this.isExpired(veh['fcExpiryDate']);
      } 
      if (veh['insuranceExpiryDate'] && this.isExpired(veh['insuranceExpiryDate']) == true) {
        obj['expiryTrueIns'] = this.isExpired(veh['insuranceExpiryDate']);
      } 
      if (veh['pucExpiryDate'] && this.isExpired(veh['pucExpiryDate']) == true) {
        obj['expiryTruepuc'] = this.isExpired(veh['pucExpiryDate']);
      }
      return obj;
    });
    setTimeout(() => { this.enableTable = true; }, 100);
  }
  isExpired(timestamp) {
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    let currentD = currentDate.getTime();
    return timestamp < currentD 
  }
  processPagination(data, req) {
    this.enableTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.enableTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    this.datacount = total;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getListVehicle(data.page, data.limit, this.searchInputValue);
  }

  /* count */
  getVendorData() {
    const obj = {
      orgID: this.orgID,
      vendorID: this.vendorID
    };
    this.allVehicle = 0;
    this.activeVehicle = 0;
    this.inActiveVehicle = 0;
    this.api.transportManagerVendorList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vendorViewData = res.data[0];
        if (res.vehicles) {
          if (res.vehicles.all) this.allVehicle = res.vehicles.all;
          if (res.vehicles.active) this.activeVehicle = res.vehicles.active;

          if (res.vehicles.inActiveVeh) this.inActiveVehicle = res.vehicles.inActiveVeh;

        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }


  loadTabContant(type: string) {

    this.noVehicleEnable = false;
    this.selectedType = type;
    this.allVehicleTotalInfo = [];

    if (type == 'all') {
      this.allVehicleTotalInfo = this.allVehicle;
    } else if (type == 'active') {
      this.allVehicleTotalInfo = this.activeVehicle;
    } else if (type == 'inActive') {
      this.allVehicleTotalInfo = this.inActiveVehicle;
    }
    if (this.allVehicleTotalInfo.length > 0) this.noVehicleEnable = true;
    else {
      setTimeout(() => {
        this.noVehicleEnable = true;
      }, 500);
    }
  }

  async filterData(type?) {
    const data = this.socketStore.get();
    const currnentTMS = new Date().getTime();

    const restrictedDays = new Date().setDate(new Date().getDate() - 2);
    const restrictedDatetime = new Date(restrictedDays).setHours(0, 0, 0, 0);
    const restrictedTimestamp = new Date(restrictedDatetime).getTime();

    data.filter(async (item: any) => {
      if (item != undefined && item.gpsts != undefined) {
        const timeDiff = this.comService.timeDiff((String(item.gpsts).length > 10 ? item.gpsts : item.gpsts * 1000), currnentTMS);
        if (restrictedTimestamp < (String(item.gpsts).length > 10 ? item.gpsts : item.gpsts * 1000)) {
          this.totalVehicle.info.all.push(item);
          this.totalVehicle.cnt.all++;
          if (item.spd <= 5) {
            this.totalVehicle.info.inActive.push(item);
            this.totalVehicle.cnt.inActive = this.totalVehicle.info.inActive.length;
          } else if (item.spd > 5) {
            this.totalVehicle.info.active.push(item);
            this.totalVehicle.cnt.active = this.totalVehicle.info.active.length;
          }
        }
      }


    });


    if (type == 'all') {
      this.allVehicleTotalInfo = this.totalVehicle.info.all;
    } else if (type == 'active') {
      this.allVehicleTotalInfo = this.totalVehicle.info.active;
    } else if (type == 'inActive') {
      this.allVehicleTotalInfo = this.totalVehicle.info.inActive;
    }

  }

  getVehicleStatus() {

    this.loadTabContant('all');
    this.filterData(this.selectedType);

  }
  // search
  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getListVehicle(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getListVehicle(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  downloadTemplate() {
    const headerRow = this.vehicleExcelColumns.map((column) => column.label);
    const sampleRow = this.vehicleExcelColumns.map((column) => column.sampleValue || '');
    const columnWidths = [];
    const headerCells = [];

    this.vehicleExcelColumns.forEach((column, index) => {
      const cellName = `${String.fromCharCode(65 + index)}1`;
      columnWidths.push({ colNo: index + 1, width: Math.max(column.label.length + 8, 22) });
      headerCells.push({
        cell: cellName,
        value: column.required ? {
          richText: [
            { text: column.label, font: { bold: true, color: { argb: 'FF000000' } } },
            { text: ' *', font: { bold: true, color: { argb: 'FFFF0000' } } }
          ]
        } : column.label,
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD9D9D9' }
        },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        },
        alignment: {
          vertical: 'middle',
          horizontal: 'center'
        }
      });
    });

    this.excel.generateExcel({
      Template: {
        data: {
          data: [],
          columWith: columnWidths
        },
        customizedData: [
          {
            value: headerRow,
            cellConfig: {
              cells: headerCells
            }
          },
          {
            value: sampleRow,
            border: {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            }
          }
        ]
      }
    }, 'Vehicle_Template.xlsx');
  }

  uploadExcelFile() {
    document.getElementById('vehicleExcelUpload').click();
  }

  uploadVehicle(event) {
    const file = event.target.files[0];
    if (!file) return;

    this.xlFileName = file.name;
    this.enableFileName = true;

    // Validate file type
    const validExtensions = ['.csv', '.xls', '.xlsx', '.xlsm', '.xml'];
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    if (!validExtensions.includes(fileExtension)) {
      this.swal.swalFunction('error', 'Invalid File', 'Please upload a valid Excel file (.xlsx, .xls, .csv)', 5000);
      let doc: any = document.querySelector('#vehicleExcelUpload');
      doc.value = '';
      return;
    }

    // Validate file size (max 2 MB)
    const maxFileSize = 2 * 1024 * 1024;
    if (file.size > maxFileSize) {
      this.swal.swalFunction('error', 'File Too Large', 'File size must not exceed 2 MB', 5000);
      let doc: any = document.querySelector('#vehicleExcelUpload');
      doc.value = '';
      return;
    }

    let apiObj = {
      vendorID: this.vendorID
    };
    let url = 'organization/excel/addVehicle';
    this.api.xlsxFileUpload(apiObj, url, 'vehicleExcelUpload', (res: any) => {
      // Handle API response
      if ((res.responseJSON.exitsData && Object.keys(res.responseJSON.exitsData).length > 0) || 
          (res.responseJSON.validationFails && Object.keys(res.responseJSON.validationFails).length > 0)) {
        this.exlUploadRes = res.responseJSON;
        this.closeExlUploadAlert = false;
      }
      else if (res.responseJSON.status == 'success' && res.responseJSON.message) {
        this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 5000);
        // Refresh vehicle list after successful upload
        setTimeout(() => {
          this.getListVehicle();
        }, 1000);
      }
      else if (res.responseJSON.status == 'failure') {
        this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 10000);
      }
      
      // Reset file input
      let doc: any = document.querySelector('#vehicleExcelUpload');
      doc.value = '';
    });
  }

  onActionHandler(e: any) {
    const data = e.data;
    let view = 'view'
    if (e.action.display.toLowerCase() == 'update') {
      this.router.navigate(['/organization/transport-manager/information/vehicle/edit-vehicle', this.vendorID, e.data.vehicleID]);
      // for (let f of this.VehicleInfo) {
      //   let name = f['name'];
      //   let value = '';
      //   if (f.type == 'dropdown') {
      //     let val = data[name].split(',');
      //     let temp = [], str = [];
      //     val.map(item => { temp.push({ value: val, name: val }); str.push(item) });
      //     f.selected = temp;
      //     f['value'] = str.join(',');
      //   } else if (f.type == 'checkbox') {
      //     let spStr = data[name].split(',')
      //     for (let op of f.options) {
      //       if (spStr.indexOf(op.value) !== -1) op.selected = true;
      //     }
      //   } else {
      //     if (name == 'email') value = 'emailID';
      //     else value = name;
      //     f['value'] = data[value];
      //   }

      // }
      // this.editForm = true;
    } else if (e.action.display.toLowerCase() == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteVehicleData(e);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.router.navigate(['/organization/transport-manager/information/vehicle/vehicle-view', this.vendorID, e.data.vehicleID, view]);
    }
  }
  deleteVehicleData(e?) {

    const obj = {
      vendorID: this.vendorID,
      vehicleID: e.data.vehicleID,
    };
    this.api.transportManagerVehicleDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getListVehicle(1, this.paginationData.limit, this.searchInputValue);
      } else {
        Swal.fire({
          icon: res['status'].toLowerCase(),
          title: res['status'],
          text: res['message'],
        });
        // this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  submitted(e: any) {
    console.log(e);
  }
  submitForm(e: any) {

    if (e == 0) { this.editForm = false; } else {
      console.log(e);
    }
  }

  downloadXlFile() {
    this.api.transportMangerVehicleListExcel({ "vendorID": this.vendorID }).then((res: any) => {
      if(res.status== 'success'){
        if(res.data.length > 0){
          this.vehExcelData=res.data;      
          this.exportToExcel()
        }else {
          this.swal.swalFunction('Info', '', 'No data found', 5000)
        }
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  private formatReportText(value: any, titleCase = false) {
    if (value === null || value === undefined || value === '') return '---';
    const normalizedValue = Array.isArray(value) ? value.join(', ') : String(value);
    return titleCase ? this.comService.convertTitleCase(normalizedValue) : normalizedValue;
  }

  private formatStatus(value: any) {
    if (value === true || value === 1 || value === '1' || value === 'true') return 'Active';
    if (value === false || value === 0 || value === '0' || value === 'false') return 'Inactive';
    return this.formatReportText(value);
  }


  async exportToExcel() {
      this.excelData = {};
      let data = [];
      let serialNo = 1;
      const vehicleReportColumns = [
        { header: 'S No', width: 10 },
        { header: 'Reg No', width: 18 },
        { header: 'IMEI', width: 20 },
        { header: 'Make', width: 18 },
        { header: 'Model', width: 18 },
        { header: 'Capacity', width: 12 },
        { header: 'Vehicle Type', width: 18 },
        { header: 'Branch', width: 18 },
        { header: 'Vehicle Registration Date', width: 22 },
        { header: 'Location', width: 20 },
        { header: 'Box Type', width: 20 },
        { header: 'Sim No', width: 18 },
        { header: 'Vendor Name', width: 22 },
        { header: 'Status', width: 14 },
        { header: 'Fuel Type', width: 16 },
        { header: 'Chassis No', width: 22 },
        { header: 'Engine No', width: 22 },
        { header: 'Route Permit No', width: 20 },
        { header: 'RC No', width: 18 },
        { header: 'RC Start Date', width: 18 },
        { header: 'RC Expiry Date', width: 18 },
        { header: 'Insurance Expiry Date', width: 22 },
        { header: 'FC Expiry Date', width: 18 },
        { header: 'PUC Expiry Date', width: 18 }
      ];
      for (let i = 0; i < this.vehExcelData.length; i++) {
        let item = this.vehExcelData[i];
          try {
              let res = {
                value: [
                  serialNo++,
                  item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
                  this.formatReportText(item.imei),
                  this.formatReportText(item.make, true),
                  this.formatReportText(item.model),
                  this.formatReportText(item.capacity),
                  this.formatReportText(item.vehicleType, true),
                  this.formatReportText(item.branch, true),
                  item.vehRegDate ? this.comService.timestampToDate(item.vehRegDate, 'DMY') : '---',
                  this.formatReportText(item.location),
                  this.formatReportText(item.boxType),
                  this.formatReportText(item.simNo),
                  this.formatReportText(item.vendorName, true),
                  this.formatStatus(item.isActive),
                  this.formatReportText(item.fuelType, true),
                  this.formatReportText(item.chassisNo, true),
                  this.formatReportText(item.engineNo, true),
                  this.formatReportText(item.routePermitNo, true),
                  this.formatReportText(item.rcNo, true),
                  item.rcStartDate ? this.comService.timestampToDate(item.rcStartDate, 'DMY') : '---',
                  item.rcExpiryDate ? this.comService.timestampToDate(item.rcExpiryDate, 'DMY') : '---',
                  item.insuranceExpiryDate ? this.comService.timestampToDate(item.insuranceExpiryDate, 'DMY') : '---',
                  item.fcExpiryDate ? this.comService.timestampToDate(item.fcExpiryDate, 'DMY') : '---',
                  item.pucExpiryDate ? this.comService.timestampToDate(item.pucExpiryDate, 'DMY') : '---',
                ],

                border: {
                  right: { style: 'thin' }, bottom: { style: 'thin' },
                },
              };
              data.push(res);
            

          } catch (err) {
            console.log(err);
          }
      }
      if (data.length > 0) {
        let rowCount = 2;
        let endCell = String.fromCharCode(64 + vehicleReportColumns.length);
        let customizedData = [];
        let titleRow = {
          value: ['Vehicle master report'],
          font: {
            name: 'Corbel', family: 4, size: 16, bold: true,
            color: { argb: 'FFFFFFFF' },
          },
          mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
          alignment: {
            cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
          },
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '966462AF' },
            bgColor: { argb: 'FFF' }
          },
        }
        customizedData.push(titleRow);
        rowCount = rowCount + 2;

        let headerRow =
        {
          value: vehicleReportColumns.map((column) => column.header),
          font: { bold: true },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        }
        customizedData.push(headerRow);

        customizedData.push(...data);
        let excelSheetName = 'Vehicle master report'

        if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

        this.excelData[excelSheetName] = {
          customizedData: customizedData,
          data: {
            columWith: vehicleReportColumns.map((column, index) => ({ colNo: index + 1, width: column.width })),
          }
        }
        this.downloadExlReport('Vehicle master report');
      }
    } 


  downloadExlReport(data: string) {
    this.excel.generateExcel(this.excelData, data + new Date().getTime() + '.xlsx');
  }
}

